import React, { MouseEvent, memo } from 'react'
import { SortArrowToggle } from 'transfix-ui/components/SortArrowToggle'
import { IUseFacilityParamsState, SortFieldType } from 'apps/fleet-planner/hooks/useFacilityParams'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

interface IFacilitiesTableHeader {
  params: IUseFacilityParamsState
  onChange: (sortField: SortFieldType) => void
}

export const FacilitiesTableHeader = memo<IFacilitiesTableHeader>(({ onChange, params }) => {
  const sortHandler = (e: MouseEvent<HTMLButtonElement>) =>
    onChange(e.currentTarget.value as SortFieldType)
  return (
    <TableHead>
      <TableRow tableCellType='th'>
        <TableCell className='pl6' dataTest='facility-name-column-header'>
          <button className='sort' value='name' onClick={sortHandler}>
            Facility Name{' '}
            <SortArrowToggle
              direction={params.sortField === 'name' ? params.sortOrder : undefined}
            />
          </button>
        </TableCell>
        <TableCell dataTest='street-address-column-header'>Street Address</TableCell>
        <TableCell dataTest='city-column-header'>City</TableCell>
        <TableCell dataTest='primary-contact-header'>Primary Contact</TableCell>
        {/* Temporarily hiding the other contacts column until facility contact editing is implemented */}
        {/* <TableCell dataTest='other-contacts-column-header'>Other Contacts</TableCell> */}
        <TableCell dataTest='last-modified-column-header'>Last Modified</TableCell>
      </TableRow>
    </TableHead>
  )
})
